import { styled, TextField } from "@mui/material"

export const OrderTextField = styled(TextField)(
  ({
    theme: {
      palette: { text },
    },
  }) => ({
    input: {
      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
        WebkitAppearance: "none",
      },
      MozAppearance: "textfield",
      color: text.primary,
      padding: "0 8px",
    },
    label: {
      // otherwise label changes color when input receives focus
      "&.Mui-focused": {
        color: text.secondary,
      },
      color: text.secondary,
    },
  }),
)
